// extracted by mini-css-extract-plugin
module.exports = {"logo":"_5D25rSyN","title":"_5Dq5SWCH","content":"_5D2t2Sit"};